<template lang="pug">
vm-row(class="card-custom" vm-w="12")
  vm-col(class="card-custom__titles" vm-type="flex" vm-align="center" vm-w=3)
    .card-custom__titles__icon
      vm-icon(icon="person-outline" size="1rem")
    .card-custom__titles__text
      h5  {{ $t('quotations.project') }}
      h3 {{ project.name }}
  vm-col(class="card-custom__titles divider" vm-type="flex" vm-align="center" vm-w=3)
    .card-custom__titles__icon
      vm-icon(icon="person-outline" size="1rem")
    .card-custom__titles__text
      h5  {{ $t('quotations.customer') }}
      h3 {{ project.customer_display }}
  vm-col(class="card-custom__titles divider" vm-type="flex" vm-align="center" vm-w=3)
    .card-custom__titles__icon
      vm-icon(icon="book-outline" size="1rem")
    .card-custom__titles__text
      h5  {{ $t('quotations.contact') }}
      h3 {{ project.customer.email }}
  vm-col(class="card-custom__titles divider" vm-type="flex" vm-align="center" vm-w=3)
    .card-custom__titles__icon
      vm-icon(icon="calendar-outline" size="1rem")
    .card-custom__titles__text
      h5  {{ $t('projects.authorization_date') }}
      h3 {{ project.authorization_date | moment("DD MMMM YYYY")}}
</template>
<script>
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('ProjectsDashboard')
const TitleCard = () => import('@/components/aditionals/TitleCard.vue')

export default {
  name: 'TitlesCard',
  components: {
    TitleCard
  },
  mixins: [ViewMixinMaster1],
  data: () => ({}),
  computed: {
    ...mapGetters(['project'])
  },
  methods: {
    ...mapActions([])
  }
}
</script>
<style lang="scss">
.card-custom {
  height: 140px;
  margin: 10px auto;
  background: white;
  padding: 25px;
  border-radius: 25px;
  box-shadow: -1px 3px 4px -1px rgba(0,0,0,0.21);
  h5 {
    color: #9EA5AB;
    font-size: 18px;
    font-weight: 600;
    line-height: 21px;
    margin-bottom: 10px;
  }
  h3 {
    font-size: 20px;
    line-height: 30px;
  }
  .divider {
    border-left: 1px solid rgba($color: var(--gray), $alpha: 1.0);
  }
  &__titles {
    display: flex;
    flex-direction: row;
    &__icon {
      margin: 25px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 25px;
      height: 25px;
      border-radius: 10px;
      padding: 14px;
      background-color: rgba($color: var(--primary), $alpha: 1.0);
      color: #FCFCFD;
    }
  }
}
</style>
